import styles from './EditPage.module.scss';

const EditPage = (props) => {
	const { editPage } = props;
	return <div className={`${styles.root} page`}>{editPage}</div>;
};

export default EditPage;
